module.exports = global.config = {
  APIURL: {
    BaseURL: "https://jewelsofjoy.online/",
  },
  //BaseURL: "https://client-1.local/",
  //BaseURL: "http://103.91.186.224:9000/",
  // other global config variables you wish
};
